// ScrollLock
// -------------------------------------------------------------------------------------------------------
const scroll_lock = {
  disable: (scrollable_el) => bodyScrollLock.disableBodyScroll(scrollable_el, { reserveScrollBarGap: true }),
  enable: (unscrollable_el) => bodyScrollLock.enableBodyScroll(unscrollable_el),
};

export default scroll_lock;
